import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { map, catchError } from 'rxjs/operators';

import { SecurityService } from '../../Core/Security/security.service';
import { ConfigService } from '../../Core/Abstract/config.service';
import { LogService } from '../../Core/Abstract/log.service';
import { GridService } from '../../Core/Abstract/grid.service';

import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { Router } from '@angular/router';

@Injectable()

export class ClaccService extends GridService{

     constructor(http:HttpClient,configService:ConfigService,eventsEmitterService: EventsEmitterService, router:Router, logger:LogService) {
        super(http,configService,eventsEmitterService, router, logger, "ClaccService");
    }
  
    initData( params:any ): Observable<any>{
        let serviceUrl = this.baseUrl   + this.serviceName + '/init?'
                                        + 'busType=' + params.bustypeCd
                                        + '&agrmType=' + params.agrmtypeCd
                                        + '&confType=' + params.confdntypeCd
                                        + '&currId=' + params.currCd;
                                        
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

}